import { graphql } from '@graphql/gql';

export const AUTHORIZE_PUB_NUB_ENTITY = graphql(`
  query AUTHORIZE_PUB_NUB_ENTITY($authKey: ID!, $entityId: ID!) {
    authorizePubNubEntity(authKey: $authKey, entityId: $entityId) {
      publishKey
      subscribeKey
      authKey
      channels
    }
  }
`);
